import styled from 'styled-components'

export const Container = styled.div`
  position: relative;
  flex: 1;

  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  h1 {
    margin-top: 22px;
    text-align: center;
    font-size: 18px;
    line-height: 24px;
    letter-spacing: 0px;
    color: ${props => props.theme.colors.color565e6b};
  }

  span {
    white-space: pre-wrap;
    font-size: 14px;
    line-height: 20px;
    color: ${props => props.theme.colors.color565e6b};
    text-align: center;
  }
`
